import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function CampaignSupportPanel() {
  const [userId, setUserId] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const complete = async () => {
    setBusy(true);
    try {
      const response = await api.post("/admin/support/campaign/complete-active", { user_id: userId.trim(), confirm: confirmed });
      setResult(response.data);
      toast.success(`${response.data.province_name} campaign completed for ${response.data.user_name || response.data.user_id}`);
    } catch (error) {
      toast.error(apiErr(error));
    } finally {
      setBusy(false);
    }
  };

  return <section data-testid="campaign-support-panel" className="mb-6 border border-red-900/50 bg-red-950/15 p-4">
    <h3 className="font-cinzel text-sm uppercase tracking-widest text-red-200">Campaign Support Completion</h3>
    <p className="mt-1 text-sm text-zinc-400">Completes only the user’s currently active expedition through the normal finale reward path. This is permanent.</p>
    <div className="mt-4 flex flex-wrap items-end gap-3">
      <label className="min-w-[260px] flex-1 text-xs uppercase tracking-wide text-zinc-500">User ID
        <input data-testid="campaign-support-user-id-input" value={userId} onChange={(event) => setUserId(event.target.value)} placeholder="user_..." className="mt-1 w-full border border-zinc-700 bg-zinc-950 px-3 py-2 text-sm normal-case text-zinc-100 outline-none focus:border-red-400" />
      </label>
      <label className="flex items-center gap-2 pb-2 text-sm text-zinc-300"><input data-testid="campaign-support-confirm-checkbox" type="checkbox" checked={confirmed} onChange={(event) => setConfirmed(event.target.checked)} /> I confirm the active expedition should be completed.</label>
      <button data-testid="campaign-support-complete-button" type="button" onClick={complete} disabled={busy || !userId.trim() || !confirmed} className="border border-red-500/70 px-4 py-2 text-sm font-cinzel uppercase tracking-wide text-red-100 transition-colors hover:bg-red-950/50 disabled:opacity-50">Complete Active Campaign</button>
    </div>
    {result && <p data-testid="campaign-support-result" className="mt-3 text-sm text-emerald-300">Completed {result.province_name}. Capstone reward queued: {result.pending_legendary_reward ? "yes" : "no"}.</p>}
  </section>;
}